import { Constants } from '@/assets'
import { Routes } from '@/assets/configs'
import { SearchFiltersValues, SearchType } from '@/modules/Search/apiTypes/base'

export const appendParamsIfNeeded = (
  route: string,
  params: Record<string, string | number | boolean | undefined> = {},
): string => {
  const keys = Object.keys(params)

  if (keys?.length) {
    // Create URL to extract pathname and searchParams (host will be ignored)
    const url = new URL(route, Constants.rootUrl)

    const { pathname, searchParams = new URLSearchParams(), hash } = url

    keys.forEach((key) => {
      const value = params[key]?.toString()

      if (value !== undefined) {
        if (key === 'nextPage') {
          if (value === Routes.Home) {
            // Remove nextPage if '/home' because it is the default
            return
          }
          const nextUrl = new URL(value, Constants.apiUrl)
          if (nextUrl.pathname === pathname) {
            return
          }
        }

        searchParams.set(key, value)
      } else {
        searchParams.delete(key)
      }
    })

    if ([...searchParams].length) {
      return `${pathname}?${searchParams.toString()}${hash}`
    }
  }

  return route
}

type SearchParamsType = SearchFiltersValues & {
  searchType?: SearchType
  itemsPerPage?: number
  page?: number
  latitude?: number
  longitude?: number
  ['customer-id']?: string
}

export const appendSearchParams = (route: string, params: SearchParamsType): string => {
  const keys = Object.keys(params)

  if (keys?.length) {
    // Create URL to extract pathname and searchParams (host will be ignored)
    const url = new URL(route, Constants.rootUrl)

    const { pathname, searchParams = new URLSearchParams() } = url

    keys.forEach((key) => {
      const value = params[key]?.toString()
      value ? searchParams.set(key, value) : null
    })

    Object.keys(params)
      .filter((filterKey) => {
        if (Array.isArray(params[filterKey])) return !params[filterKey].length
        return !params[filterKey]
      })
      .forEach((paramsKeyToDelete) => {
        searchParams.delete(paramsKeyToDelete)
      })

    if ([...searchParams].length) {
      return `${pathname}?${searchParams.toString()}`
    }
  }

  return route
}

export const getFirstQueryParam = (param: string | string[] | undefined): string | undefined => {
  return typeof param === 'string' ? param : param ? param[0] : undefined
}

/**
 * Delete selected query key and return full path
 * @param route
 * @param queryKey
 */
export const deleteQueryParam = (route: string, queryKey: string): string => {
  const url = new URL(route, Constants.rootUrl)
  const { pathname, searchParams = new URLSearchParams(route) } = url
  searchParams.delete(queryKey)
  return `${pathname}?${searchParams.toString()}`
}

/**
 * Get selected 'key' query params
 * @param route
 * @param key
 */
export const getQueryParam = (route: string, key: string) => {
  const queryParams = new URLSearchParams(route)
  return queryParams.get(key)
}
